import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RoundEditModalComponent } from '../round-edit-modal/round-edit-modal.component';

@Component({
  selector: 'app-round-item',
  templateUrl: './round-item.component.html',
  styleUrls: ['./round-item.component.scss']
})
export class RoundItemComponent implements OnInit {

  @Input() id: string = null;
  @Input() name: string = '';
  @Input() place_from: string = '';
  @Input() place_to: string = '';

  public is_staff: boolean = false;

  constructor(
    private modalService: NgbModal,
  ) { }

  ngOnInit(): void {
    // @ts-ignore
    this.is_staff = window['iAmStaff'];
  }

  getPlacesClass(): string {
    if (this.place_to === 'None' && this.place_from === 'None') {
      return 'noneTextColor';
    }
    return '';
  }

  open() {
    if (this.is_staff) {
      const modalRef = this.modalService.open(RoundEditModalComponent, {
        size: 'lg'
      });
      modalRef.componentInstance.id = this.id;

      modalRef.result.then(() => {
        modalRef.componentInstance.triggerUpdate();
      }, () => {
        modalRef.componentInstance.triggerUpdate();
      });
    }
  }

  tourStyle(): string {
    return this.is_staff
      ? 'b-tournament-bracket__round-title tourStep'
      : 'b-tournament-bracket__round-title tourStep noCursor';
  }

}
